import React, { useState, useContext } from 'react';
import { func, oneOf } from 'prop-types';
import classNames from 'classnames/bind';

import FieldSearchPart from 'components/SearchByVin/components/FieldSearchPart';
import CarDetails from 'components/CarDetails';
import CountrySelector from 'components/CountrySelector';
import FieldSearchKba from './components/FieldSearchKba';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import { StaticTextContext } from 'context/StaticTextContext';
import { SearchContext } from 'context/SearchContext';

import { isGlobalSite } from 'utils/currentLanguage';
import { gtmPushEvent } from 'utils/gtmPushEvent';
import { getBrowserHistory } from 'utils/historyPushSearch';
import { redirectToTechAssist } from 'utils/redirectToTechAssist';
import browserHistory, { isTechAssistPage } from 'utils/browserHistory';

import styles from './SearchByKba.module.scss';
import SearchIcon from 'media/icons/search.icon.svg';

const cx = classNames.bind(styles);

const SearchByKba = ({ getArticlesIds, pageType }) => {
  const [partValue, setPartValue] = useState('');
  const [partData, setPartData] = useState([]);
  const { labels } = useContext(StaticTextContext);
  const {
    isCarTooltip,
    isPartTooltip,
    isSelectedKba,
    kbaNumber,
    partName,
    partId,
    carName,
    carId,
    manuId,
    modelId,
    setIsPartTooltip,
    setIsCarTooltip,
    setSearchCarQuery,
  } = useContext(SearchContext);

  const isSelectedPart = !!partName && partName.length > 0;
  const { search, hash } = browserHistory.location;

  const handleSearch = (event) => {
    event.preventDefault();
    const searchObj = {
      kbaNumber,
      carId,
      carName,
      manuId,
      modId: modelId,
      partName,
      partId,
    };

    // Send gtm search event
    const pushKba = {
      event: 'searchProductCarKba',
      kba: kbaNumber,
      product: partName,
    };
    gtmPushEvent(pushKba);
    
    setIsCarTooltip(false);
    setIsPartTooltip(false);
    setSearchCarQuery(partName + ', ' + carName);

    if (pageType === 'home') {
      if (!isTechAssistPage) {
        redirectToTechAssist(getBrowserHistory(searchObj, search, hash));
        return null;
      }
      browserHistory.push({
        pathname: '/search',
        search: getBrowserHistory(searchObj, search, hash),
      });
    } else {
      getArticlesIds();
    }
  };

  return (
    <form
      onSubmit={handleSearch}
      className={cx('search-form', pageType, {
        'opened-tooltip': isPartTooltip || isCarTooltip,
      })}
    >
      {isGlobalSite && (
        <div className={cx('form-item')}>
          <CountrySelector />
        </div>
      )}
      <div className={cx('control-wrap')}>
        <div className={cx('form-item', 'form-item-kba')}>
          <FieldSearchKba
            pageType={pageType}
            setPartValue={setPartValue}
            setPartData={setPartData}
            partData={partData}
          />
        </div>

        <div className={cx('form-item', 'form-item-part')}>
          <FieldSearchPart
            partValue={partValue}
            partData={partData}
            pageType={pageType}
            isSelectedPart={isSelectedPart}
            setPartValue={setPartValue}
          />
        </div>

        <button
          type="submit"
          className={cx('btn', 'ta-btn-primary')}
          disabled={!(isSelectedKba && isSelectedPart)}
        >
          <span className={cx('btn-icon')}>
            <SearchIcon />
          </span>
          <span className={cx('btn-text')}>{labels.searchButtonText}</span>
        </button>
      </div>
      {pageType === 'search' && <CarDetails />}
    </form>
  );
};

SearchByKba.propTypes = {
  pageType: oneOf(['home', 'search']),
  getArticlesIds: func.isRequired,
};

SearchByKba.defaultProps = {
  pageType: 'home',
};

export default withErrorBoundary(SearchByKba);



// WEBPACK FOOTER //
// ./src/components/SearchByKba/SearchByKba.js